import { render } from "./CodeToPhone.vue?vue&type=template&id=5f4aaa78&scoped=true"
import script from "./CodeToPhone.vue?vue&type=script&lang=js"
export * from "./CodeToPhone.vue?vue&type=script&lang=js"

import "./CodeToPhone.vue?vue&type=style&index=0&id=5f4aaa78&scoped=true&lang=scss"
import "./CodeToPhone.vue?vue&type=style&index=1&id=5f4aaa78&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f4aaa78"]])

export default __exports__